import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ValidationError } from '@nextinq.public/usable-form/lib/types';
import { colors } from '@nextinq/ui-toolkit';
import { Icon } from '../icon';
import { sizes } from '../../themes/sizes';
import cx from 'classnames';

const Wrapper = styled.section`
  display: grid;
  grid-gap: ${sizes.margins.small};
  margin-bottom: ${sizes.margins.huge};
  .ui.input,
  .ui.dropdown {
    width: 100%;
  }
`;

const Label = styled.label``;
const HelpText = styled.div`
  color: ${colors.grey.greyLighter};
  font-size: smaller;
`;
const FieldWrapper = styled.div``;

export interface InputWrapperProps {
  label?: string | null;
  children?: ReactNode;
  required?: boolean;
  touched?: boolean;
  error?: string | ValidationError | null | undefined;
  helperText?: string;
}

export function InputWrapper(props: InputWrapperProps) {
  const { error, touched, label, required, children, helperText } = props;
  const fieldClasses = cx('field', { error, required });
  return (
    <Wrapper className={fieldClasses}>
      <Label>{label}</Label>
      <FieldWrapper>{children}</FieldWrapper>
      {/*
        `error` may be a ValidationError object, not a string. Rendering it
        directly makes React throw "Objects are not valid as a React child" —
        masked until now because the old tsconfig was not strict. Matches what
        ui-toolkit's ErrorItem already did.
      */}
      {error && touched && (
        <div className="error">{typeof error === 'string' ? error : error.message}</div>
      )}
      {helperText && (
        <HelpText>
          <Icon name="help circle" size="small" />
          {helperText}
        </HelpText>
      )}
    </Wrapper>
  );
}
